<div class="app-view-container h-full flex flex-col">
  <div class="main-actions">
    <div class="actions-container">
      <div class="tab-navigation h-auto justify-between items-center">
        <sp-navigation-link *ngIf="navLinks.length > 1" [navLinks]="navLinks" (selectedTab)="currentTabClick($event)"></sp-navigation-link>
      </div>
      <div class="page-actions align-middle">
        <div class="flex items-center">
          <!--
            - Checks if the branding is 'not' one of the specified clients (SEAT, VKB, Vorwerk)
            - If the current tab is asset downloads.
            - The user has permission to export download
            If all conditions are met, it renders the export download buttons.
          -->
          @if (![CustomClients.SEAT, CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey) && currentTab === assetsDetailViewTabs.AssetDownloads) {
            <ng-container *thehubzCanRole="{ role: ['export.downloads'], accessType: 'AccessAsset', assetInfo: assetInfo }">
              <ng-container *ngTemplateOutlet="exportDownloadButtons; context: flatButtonContext"></ng-container>
            </ng-container>
          }
          <!--
            - Checks if the branding is 'not' one of the specified clients (SEAT, VKB, Vorwerk)
            - If the current tab is asset version.
            - The asset has not expired
            - The user has permission to upload version
            If all conditions are met, it renders the new version buttons.
          -->
          @if (![CustomClients.SEAT, CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey) && currentTab === assetsDetailViewTabs.AssetVersions && (assetInfo?.expiryDate | dateNotExpired)) {
            <ng-container *thehubzCanRole="{ role: ['version'], accessType: 'AccessAsset', assetInfo: assetInfo }">
              <ng-container *ngTemplateOutlet="newVersionButtons; context: flatButtonContext"></ng-container>
            </ng-container>
          }
          <!--
            - If the current tab is asset buyout rights.
            - The user has permission to add usagerights
            If all conditions are met, it renders the usagerights buttons.
          -->
          @if (currentTab === assetsDetailViewTabs.AssetBuyoutRights && screenSizeDetectorService.isLargeScreen) {
            <ng-container *thehubzCanRole="{ role: ['usagerights'], accessType: 'AccessAsset', assetInfo: assetInfo }">
              <button mat-flat-button [disabled]="uploadInProgress" (click)="newBuyoutRights()" class="w-auto button-primary mr-4">
                <mat-icon class="material-icons-outlined mr-1">add_box</mat-icon>
                <ng-container i18n>Add buyout rights</ng-container>
              </button>
            </ng-container>
          }
          <!--
            - Checks if the branding is 'not' one of the specified clients (SEAT, VKB, Vorwerk)
            - If the current tab is asset aspect ration.
            - The user has permission to upload aspect ration files
            If all conditions are met, it renders the AspectRatio buttons.
          -->
          @if (![CustomClients.SEAT, CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey) && currentTab === assetsDetailViewTabs.AssetAspects) {
            <ng-container *thehubzCanRole="{ role: ['aspectratios'], accessType: 'AccessAsset', assetInfo: assetInfo }">
              <ng-container *ngTemplateOutlet="newAspectRatioButtons; context: flatButtonContext"></ng-container>
            </ng-container>
          }
          <!-- Check if the current screen size is large before rendering the contents below -->
          <ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
            <!--
              - Checks if the branding is 'not' one of the specified clients (Vorwerk, Arval)
              - The asset has not expired
              - The user has permission to download the expired asset
              - The user has permission to download the asset
              If all conditions are met, it renders the download asset buttons.
            -->
            @if (![CustomClients.Vorwerk, CustomClients.Arval].includes(brandingKey) && assetInfo && ((assetInfo.expiryDate | dateNotExpired) || (AccessAsset(assetInfo) | can: 'expired.download'))) {
              <ng-container *thehubzCanRole="{ role: ['download'], accessType: 'AccessAsset', assetInfo: assetInfo }">
                <ng-container *ngTemplateOutlet="downloadAssetButtons; context: flatButtonContext"></ng-container>
              </ng-container>
            }
          </ng-container>
          <!--
            - Checks if the branding is 'not' one of the specified clients (SEAT, VKB, LufthansaMediacenter, LufthansaMedialounge, Vorwerk, Arval)
            - If the current tab is asset information, data, buyout rights, usage rights, or tagging.
            - The asset has not expired
            - The user has permission to share the asset
            If all conditions are met, it renders the share asset buttons.
          -->
          <ng-container *thehubzCanRole="{ role: ['share'], accessType: 'AccessAsset', assetInfo: assetInfo }">
            @if (
              ![
                CustomClients.SEAT,
                CustomClients.VKB,
                CustomClients.LufthansaMediacenter,
                CustomClients.LufthansaMedialounge,
                CustomClients.Vorwerk,
                CustomClients.Arval,
                CustomClients.Standard,
              ].includes(brandingKey) &&
              [
                assetsDetailViewTabs.AssetInfo,
                assetsDetailViewTabs.AssetData,
                assetsDetailViewTabs.AssetBuyoutRights,
                assetsDetailViewTabs.AssetUsageRights,
                assetsDetailViewTabs.AssetTagging,
              ].includes(currentTab) &&
              assetInfo &&
              (assetInfo.expiryDate | dateNotExpired)
            ) {
              <ng-container *ngTemplateOutlet="shareAssetButtons; context: flatButtonContext"></ng-container>
            }
            <!--
            - Checks if the branding is VKB
            - The asset has not expired
            - The user has permission to share the asset
            If all conditions are met, it renders the share asset buttons.
          -->
            @if (CustomClients.VKB === brandingKey && screenSizeDetectorService.isLargeScreen && assetInfo && (assetInfo.expiryDate | dateNotExpired)) {
              <ng-container *ngTemplateOutlet="shareAssetButtons; context: flatButtonContext"></ng-container>
            }
          </ng-container>
          <div class="filter-box px-0 inline-block relative align-top" *ngIf="brandingKey === CustomClients.Vorwerk && screenSizeDetectorService.isLargeScreen">
            <button mat-icon-button [matMenuTriggerFor]="editMenu" i18n-matTooltip matTooltip="Edit" *ngIf="assetActionEditAccessibility(assetInfo)">
              <mat-icon class="material-icons-outlined">edit</mat-icon>
            </button>
            <mat-menu #editMenu="matMenu">
              <ng-container
                *ngTemplateOutlet="
                  editAssetButton;
                  context: {
                    editType: 'metaData',
                    editTypeText: editTypeTexts['metadata'],
                    role: ['update'],
                  }
                "
              ></ng-container>
              <ng-container
                *ngTemplateOutlet="
                  editAssetButton;
                  context: {
                    editType: 'usageRights',
                    editTypeText: editTypeTexts['usageRights'],
                    role: ['usagerights'],
                  }
                "
              ></ng-container>
              <ng-container
                *ngTemplateOutlet="
                  editAssetButton;
                  context: {
                    editType: 'relations',
                    editTypeText: editTypeTexts['relations'],
                    role: ['relations'],
                  }
                "
              ></ng-container>
            </mat-menu>
          </div>
          <div class="filter-box px-0 inline-block relative align-top">
            <button mat-icon-button [matMenuTriggerFor]="menu" i18n-matTooltip matTooltip="Options" *ngIf="assetActionAccessibility(assetInfo)" data-guided-tour-id="asset-menu-button">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
                @if (brandingKey !== CustomClients.Vorwerk) {
                  <ng-container
                    *ngTemplateOutlet="
                      editAssetButton;
                      context: {
                        editType: 'metaData',
                        editTypeText: editTypeTexts['metadata'],
                        role: ['update'],
                      }
                    "
                  ></ng-container>
                }
                @if (![CustomClients.Vorwerk].includes(brandingKey)) {
                  <ng-container
                    *ngTemplateOutlet="
                      editAssetButton;
                      context: {
                        editType: 'usageRights',
                        editTypeText: editTypeTexts['usageRights'],
                        role: ['usagerights'],
                      }
                    "
                  ></ng-container>
                }
                @if (brandingKey !== CustomClients.Vorwerk) {
                  <ng-container
                    *ngTemplateOutlet="
                      editAssetButton;
                      context: {
                        editType: 'relations',
                        editTypeText: editTypeTexts['relations'],
                        role: ['relations'],
                      }
                    "
                  ></ng-container>
                }
              </ng-container>
              @if (
                (![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.SEAT].includes(brandingKey) || screenSizeDetectorService.isSmallScreen) &&
                assetInfo &&
                ((assetInfo.expiryDate | dateNotExpired) || (AccessAsset(assetInfo) | can: 'expired.download'))
              ) {
                <ng-container *thehubzCanRole="{ role: ['download'], accessType: 'AccessAsset', assetInfo: assetInfo }">
                  <ng-container *ngTemplateOutlet="downloadAssetButtons; context: menuItemButtonContext"></ng-container>
                </ng-container>
              }
              <ng-container *thehubzCanRole="{ role: ['share'], accessType: 'AccessAsset', assetInfo: assetInfo }">
                @if (
                  ([CustomClients.Vorwerk, CustomClients.Arval, CustomClients.SEAT, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Standard].includes(
                    brandingKey
                  ) ||
                    (CustomClients.VKB === brandingKey && screenSizeDetectorService.isSmallScreen)) &&
                  assetInfo &&
                  (assetInfo.expiryDate | dateNotExpired)
                ) {
                  <ng-container *ngTemplateOutlet="shareAssetButtons; context: menuItemButtonContext"></ng-container>
                }
              </ng-container>

              @if (screenSizeDetectorService.isLargeScreen) {
                <ng-container *thehubzCanRole="{ role: ['collection.access'], accessType: 'AccessAsset', assetInfo }">
                  @if (![CustomClients.VKB, CustomClients.SEAT].includes(brandingKey) && assetInfo && (assetInfo.expiryDate | dateNotExpired)) {
                    <ng-container *ngTemplateOutlet="addToCollectionButtons"></ng-container>
                  }
                  @if ([CustomClients.VKB, CustomClients.SEAT].includes(brandingKey) && assetInfo && (assetInfo.expiryDate | dateNotExpired)) {
                    <ng-container *ngTemplateOutlet="addToCollectionButtons"></ng-container>
                  }
                </ng-container>
                <ng-container *thehubzCanRole="{ role: ['delete'], accessType: 'AccessAsset', assetInfo }">
                  <button mat-menu-item (click)="deleteAsset(assetInfo._id)">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>
                      <ng-container *ngIf="![CustomClients.VKB, CustomClients.SEAT].includes(brandingKey)" i18n>Delete asset</ng-container>
                      <ng-container *ngIf="[CustomClients.VKB, CustomClients.SEAT].includes(brandingKey)" i18n>Delete</ng-container>
                    </span>
                  </button>
                </ng-container>
                <ng-container *thehubzCanRole="{ role: ['plandeletion'], accessType: 'AccessAsset', assetInfo }">
                  <button mat-menu-item (click)="deleteAsset(assetInfo._id, true)">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span i18n>Plan deletion</span>
                  </button>
                </ng-container>
              }

              @if (
                [CustomClients.SEAT, CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey) && currentTab === assetsDetailViewTabs.AssetVersions && (assetInfo?.expiryDate | dateNotExpired)
              ) {
                <ng-container *thehubzCanRole="{ role: ['version'], accessType: 'AccessAsset', assetInfo }">
                  <ng-container *ngTemplateOutlet="newVersionButtons; context: menuItemButtonContext"></ng-container>
                </ng-container>
              }
              @if ([CustomClients.SEAT, CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey) && currentTab === assetsDetailViewTabs.AssetAspects) {
                <ng-container *thehubzCanRole="{ role: ['aspectratios'], accessType: 'AccessAsset', assetInfo }">
                  <ng-template [ngTemplateOutlet]="newAspectRatioButtons" [ngTemplateOutletContext]="menuItemButtonContext"> </ng-template>
                </ng-container>
              }
              @if ([CustomClients.SEAT, CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey) && currentTab === assetsDetailViewTabs.AssetDownloads) {
                <ng-container *thehubzCanRole="{ role: ['export.downloads'], accessType: 'AnyReport' }">
                  <ng-template [ngTemplateOutlet]="exportDownloadButtons" [ngTemplateOutletContext]="menuItemButtonContext"></ng-template>
                </ng-container>
              }
            </mat-menu>
            <ng-container *ngIf="assetRelationsService.vm$ | async as assetRelationsVm">
              <ng-container *ngIf="assetRelationsVm.showWheelMenu && screenSizeDetectorService.isLargeScreen">
                <button mat-icon-button [matMenuTriggerFor]="gridMenu">
                  <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
                </button>
                <mat-menu #gridMenu="matMenu">
                  <ng-template matMenuContent>
                    <sp-table-wheel-setting
                      (changeView)="changeView($event)"
                      [headerType]="'assetGallery'"
                      [menuObjects]="assetRelationsVm.menuObject"
                      [selectedViewType]="assetRelationsVm.selectedViewType"
                      [gridSettingsKeySuffix]="gridSettingsKeySuffix"
                    ></sp-table-wheel-setting>
                  </ng-template>
                </mat-menu>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="list-view app-content-container w-full overflow-y-auto h-full">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #downloadAssetButtons let-buttonType="buttonType" let-buttonClass="buttonClass">
  @switch (buttonType) {
    @case ('mat-flat-button') {
      <button mat-flat-button [ngClass]="buttonClass" (click)="downloadAsset(assetInfo)">
        <mat-icon class="material-icons-outlined mr-1">file_download</mat-icon>
        <ng-container i18n>Download asset</ng-container>
      </button>
    }
    @case ('mat-menu-item') {
      <button mat-menu-item [ngClass]="buttonClass" (click)="downloadAsset(assetInfo)">
        <mat-icon class="material-icons-outlined mr-1">file_download</mat-icon>
        <ng-container i18n>Download asset</ng-container>
      </button>
    }
  }
</ng-template>

<ng-template #exportDownloadButtons let-buttonType="buttonType" let-buttonClass="buttonClass">
  @switch (buttonType) {
    @case ('mat-flat-button') {
      <button mat-flat-button [ngClass]="buttonClass" (click)="exportDownloads()">
        <mat-icon class="material-icons-outlined">upload_file</mat-icon>
        <span class="px-2 font-bold" i18n>Export downloads</span>
      </button>
    }
    @case ('mat-menu-item') {
      <button mat-menu-item [ngClass]="buttonClass" (click)="exportDownloads()">
        <mat-icon class="material-icons-outlined">upload_file</mat-icon>
        <ng-container i18n>Export downloads</ng-container>
      </button>
    }
  }
</ng-template>

<ng-template #newVersionButtons let-buttonType="buttonType" let-buttonClass="buttonClass">
  @switch (buttonType) {
    @case ('mat-flat-button') {
      <button mat-flat-button [ngClass]="buttonClass" [disabled]="uploadInProgress" (click)="newAssetVersion()">
        <mat-icon class="material-icons-outlined mr-1">add_box</mat-icon>
        <ng-container i18n>New version</ng-container>
      </button>
    }
    @case ('mat-menu-item') {
      <button mat-menu-item [ngClass]="buttonClass" [disabled]="uploadInProgress" (click)="newAssetVersion()">
        <mat-icon class="material-icons-outlined mr-1">add_box</mat-icon>
        <ng-container i18n>New version</ng-container>
      </button>
    }
  }
</ng-template>

<ng-template #newAspectRatioButtons let-buttonType="buttonType" let-buttonClass="buttonClass">
  @switch (buttonType) {
    @case ('mat-flat-button') {
      <button mat-flat-button [ngClass]="buttonClass" [disabled]="uploadInProgress" (click)="addNewVariant()">
        <mat-icon class="material-icons-outlined mr-1">add_box</mat-icon>
        <ng-container [ngSwitch]="assetInfo.assetType">
          <ng-container *ngSwitchCase="AssetTypeEnum.Audio || AssetTypeEnum.Other" i18n>New format</ng-container>
          <ng-container *ngSwitchDefault i18n>New aspect ratio</ng-container>
        </ng-container>
      </button>
    }
    @case ('mat-menu-item') {
      <button mat-menu-item [ngClass]="buttonClass" [disabled]="uploadInProgress" (click)="addNewVariant()">
        <mat-icon class="material-icons-outlined mr-1">add_box</mat-icon>
        <ng-container [ngSwitch]="assetInfo.assetType">
          <ng-container *ngSwitchCase="AssetTypeEnum.Audio || AssetTypeEnum.Other" i18n>New format</ng-container>
          <ng-container *ngSwitchDefault i18n>New aspect ratio</ng-container>
        </ng-container>
      </button>
    }
  }
</ng-template>

<ng-template #shareAssetButtons let-buttonType="buttonType" let-buttonClass="buttonClass">
  @switch (buttonType) {
    @case ('mat-flat-button') {
      <button mat-flat-button [ngClass]="buttonClass" (click)="sharedAssetsStepper()">
        <mat-icon class="material-icons-outlined">share</mat-icon>
        <span i18n>Share asset</span>
      </button>
    }
    @case ('mat-menu-item') {
      <button mat-menu-item [ngClass]="buttonClass" (click)="sharedAssetsStepper()">
        <mat-icon class="material-icons-outlined">share</mat-icon>
        <span i18n>Share asset</span>
      </button>
    }
  }
</ng-template>

<ng-template #addToCollectionButtons>
  <button mat-menu-item (click)="addToCollection()">
    <mat-icon class="material-icons-outlined">perm_media</mat-icon>
    <span i18n>Add to collection</span>
  </button>
</ng-template>

<ng-template #editAssetButton let-editType="editType" let-editTypeText="editTypeText" let-role="role">
  <ng-template [thehubzCanRole]="{ role: role, accessType: 'AnyAsset' }">
    <button mat-menu-item (click)="editAssets(editType)">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span i18n="@@editTypeText">{{ editTypeText }}</span>
    </button>
  </ng-template>
</ng-template>
